module.exports = __webpack_public_path__ + "img/doc-file-icon.e67ced31.svg";